let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Dpbh")).then(() => parcelRequire('4r46I'));